//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
import _ from 'lodash';
export default {
  name: 'SandBoxItem',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
    jurisdiction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
        sandbox_type: '',
        sandbox_tmpl_id: '',
        desc: '',
        sandbox_name: '',
      },
      templateOptions: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'submit' }],
        sandbox_type: [{ required: true, message: '请选择类型', trigger: 'submit' }],
        sandbox_tmpl_id: [{ required: false, message: '请选择应用模版', trigger: 'submit' }],
      },
      templateObject: {},
      jsonData: {},
      showJson: false,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        console.log('%c Line:110 🍕 this.row', 'color:#e41a6a', this.row);
        this.form = _.cloneDeep(this.row);
        if (this.row.sandbox_tmpl_id !== '0') {
          this.$request({
            url: this.$api.getSandboxTemplate,
            data: {
              id: Number(this.row.sandbox_tmpl_id),
            },
          })
            .then((res) => {
              this.templateObject.desensitize_rule = res?.data?.desensitize_rule;
              this.templateObject.sync_objects = res?.data?.sync_objects;
              this.jsonData = res?.data?.desensitize_rule;
              this.$forceUpdate();
            })
            .catch((err) => {
              console.log('%c Line:126 🍊 err', 'color:#b03734', err);
              this.templateObject.desensitize_rule = '{}';
              this.templateObject.sync_objects = [];
              this.jsonData = '{}';
              this.$forceUpdate();
            });
        }
      }
    },
    form: {
      handler(newVal) {
        console.log('%c Line:99 🧀 this.form.sandbox_type', 'color:#6ec1c2', newVal);
        if (newVal.sandbox_type === 'partial') {
          this.rules.sandbox_tmpl_id = [
            { required: true, message: '请选择应用模版', trigger: 'submit' },
          ];
          // 重新验证 B 字段
          this.$refs.form.validateField('sandbox_tmpl_id');
        } else {
          this.rules.sandbox_tmpl_id = [];
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllSandboxTemplate();
  },
  methods: {
    getAllSandboxTemplate() {
      this.$request({
        url: this.$api.getAllSandboxTemplate,
        data: {},
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.templateOptions = res.list;
      });
    },
    openJsonEdit() {
      this.showJson = true;
    },
    close() {
      this.$emit('close');
    },
    edit() {
      this.$emit('close');
      this.$emit('editSandBox', this.row);
    },
  },
};
